import { render, staticRenderFns } from "./IconSecrecyBroker.vue?vue&type=template&id=6922eff8&"
import script from "./IconSecrecyBroker.vue?vue&type=script&lang=js&"
export * from "./IconSecrecyBroker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports